export const AIRLINE_NAMES_FOR_CARRIER_CODE = {
  ZO: 'Airblue',
  TZ: 'Air Tanzania',
  TK1: 'Turkish Airlines',
  EK1: 'Emirates',
  PC: 'Pegasus Airlines',
  EA: 'Eastern Airlines',
  EB: 'European Air Express',
  EC: 'OpenSkies',
  DT: 'TAAG Angola Airlines',
  E7: 'Equaflight',
  DV: 'Air Company SCAT',
  DW: 'Aero-Charter',
  DX: 'Danish Air Transport',
  DAT: 'Danish Air Transport',
  DM: 'Maersk Air',
  DL: 'Delta Air Lines',
  DN: 'Norwegian Air Argentina',
  DQ: 'Coastal Air Transport',
  DP: 'Pobeda Airlines',
  E4: 'Enter Air',
  DR: 'Ruili Airlines',
  DE: 'Condor',
  DD: 'Nok Air',
  DG: 'Cebgo',
  DH: 'Norwegian Air Norway',
  DJ: 'AirAsia Japan',
  FD: 'Thai AirAsia',
  FE: 'Far Eastern Air Transport',
  FB: 'Bulgaria Air',
  FC: 'Fly Corporate',
  F8: 'Flair Airlines',
  EW: 'Eurowings',
  F9: 'Frontier Airlines',
  EX: 'Air Santo Domingo',
  EU: 'Ecuatoriana',
  EV: 'ExpressJet',
  F7: 'iFly Airlines',
  EY: 'Etihad Airways',
  EZ: 'Sun Air of Scandinavia',
  EP: 'Iran Aseman Airlines',
  EO: 'Pegas Fly',
  EN: 'Air Dolomiti',
  EM: 'Empire Airlines',
  ET: 'Ethiopian Airlines',
  ET1: 'Ethiopian Airlines',
  ES: 'DHL Aviation',
  F3: 'Flyadeal',
  EH: 'ANA Wings',
  EF: 'Fly Easy',
  EE: 'Nordica',
  EK: 'Emirates',
  EJ: 'New England Airlines',
  EI: 'Aer Lingus',
  GE: 'TransAsia Airways',
  GF: 'Gulf Air',
  GA: 'Garuda Indonesia',
  FZ: 'Flydubai',
  FZ1: 'Flydubai',
  FZ2: 'Flydubai',
  FV: 'Rossiya Airlines',
  FW: 'Ibex Airlines',
  G8: 'Go First',
  G9: 'Air Arabia',
  FY: 'Firefly',
  G4: 'Allegiant Air',
  FS: 'Syphax Airlines',
  G3: 'Gol Transportes Aéreos',
  FR: 'Ryanair',
  G6: 'Air Indus',
  FT: 'FlyEgypt',
  G5: 'China Express Airlines',
  FN: 'Fastjet',
  FQ: 'Brindabella Airlines',
  FP: 'Pelican Airlines',
  FK: 'Keewatin Air',
  FJ: 'Fiji Airways',
  FM: 'Shanghai Airlines',
  FL: 'AirTran Airways',
  GN: 'Gambia Bird',
  FG: 'Ariana Afghan Airlines',
  FI: 'Icelandair',
  FH: 'Freebird Airlines',
  HG: 'Niki',
  HD: 'Air Do',
  HE: 'Luftfahrtgesellschaft Walter',
  HB: 'Asia Atlantic Airlines',
  HA: 'Hawaiian Airlines',
  GY: 'Colorful Guizhou Airlines',
  GZ: 'Air Rarotonga',
  GW: 'Skygreece Airlines',
  GX: 'Guangxi Beibu Gulf Airlines',
  H9: 'Himalaya Airlines',
  GV: 'Grant Aviation',
  H7: 'Eagle Aviation',
  H6: 'Hageland Aviation',
  GU: 'Aviateca',
  GT: 'Air Guilin',
  H4: 'HiSky',
  GS: 'Tianjin Airlines',
  GR: 'Aurigny',
  H2: 'Sky Airline',
  GP: 'Gansu Airlines',
  GM: 'Chair Airlines',
  GL: 'Air Greenland',
  GI: 'Itek Air',
  A4: 'Azimuth',
  A3: 'Aegean Airlines',
  A6: 'Air Alps Aviation',
  A5: 'Airlinair',
  A8: 'Benin Golf Air',
  A9: 'Georgian Airways',
  A0: 'L Avion',
  AT: 'Royal Air Maroc',
  AT1: 'Royal Air Maroc',
  AS: 'Alaska Airlines',
  AR: 'Aerolíneas Argentinas',
  B2: 'Belavia',
  AX: 'Connect Air',
  B8: 'Eritrean Airlines',
  AV: 'Avianca',
  B7: 'Uni Air',
  AU: 'Austral Líneas Aéreas',
  B6: 'JetBlue',
  AZ: 'Alitalia',
  AY: 'Finnair',
  BA: 'British Airways',
  BA1: 'British Airways',
  AC: 'Air Canada',
  AA: 'American Airlines',
  AB: 'Air Berlin',
  AB1: 'Air Berlin',
  AH: 'Air Algérie',
  AF: 'Air France',
  AK: 'AirAsia',
  AL: 'Skyway Airlines',
  AI: 'Air India',
  AI1: 'Air India',
  AJ: 'Aero Contractors',
  AP: 'AlbaStar',
  AM: 'Aeroméxico',
  BW: 'Caribbean Airlines',
  C8: 'Cargolux Italia',
  BV: 'Blue Panorama Airlines',
  BY: 'TUI Airways',
  C9: 'Cirrus Airlines',
  BS: 'US-Bangla Airlines',
  BR: 'EVA Air',
  C3: 'Contact Air',
  C6: 'CanJet',
  BU: "Compagnie Africaine d'Aviation",
  BT: 'airBaltic',
  C5: 'CommuteAir',
  CB: 'Trans Commuter',
  CA: 'Air China',
  BZ: 'Blue Bird Airways',
  BF: 'French Bee',
  BG: 'Biman Bangladesh Airlines',
  BH: 'B&H Airlines',
  BI: 'Royal Brunei Airlines',
  BB: 'Seaborne Airlines',
  BD: 'Cambodia Angkor Air',
  BE: 'Flybe',
  C0: 'Centralwings',
  BP: 'Air Botswana',
  C2: 'CEIBA Intercontinental',
  BQ: 'Aeromar',
  BJ: 'Nouvelair',
  BL: 'Jetstar Pacific',
  BM: 'bmi Regional',
  CZ: 'China Southern Airlines',
  CY: 'Cyprus Airways',
  CX: 'Cathay Pacific',
  D8: 'Norwegian Air International',
  D7: 'AirAsia X',
  CV: 'Cargolux',
  D6: 'Interair South Africa',
  CU: 'Cubana de Aviación',
  D5: 'DHL de Guatemala',
  D4: 'Alidaunia',
  CS: 'Continental Micronesia',
  DC: 'Braathens Regional Airways',
  DB: 'Brit Air',
  CI: 'China Airlines',
  CJ: 'BA CityFlyer',
  CG: 'PNG Air',
  CH: 'Bemidji Airlines',
  CE: 'Chalair Aviation',
  CF: 'City Airline',
  CD: 'Corendon Dutch Airlines',
  D2: 'Severstal Aircompany',
  CQ: 'Coastal Aviation',
  D3: 'Daallo Airlines',
  CO: 'Continental Airlines',
  CP: 'Compass Airlines',
  CM: 'Copa Airlines',
  CN: 'Grand China Air',
  CL: 'Lufthansa CityLine',
  LW: 'Pacific Wings',
  LV: 'Albanian Airlines',
  M7: 'Marsland Aviation',
  LU: 'Kenmore Air',
  M5: 'Belle Air',
  LZ: 'El Al',
  LY: 'El Al',
  LX: 'Swiss International Air Lines',
  M9: 'Motor Sich Airlines',
  LO: 'LOT Polish Airlines',
  M0: 'Aero Mongolia',
  LN: 'Libyan Airlines',
  M4: 'Mistral Air',
  LS: 'Jet2.com',
  LR: 'Avianca Costa Rica',
  M3: 'North Flying',
  M2: 'Mahfooz Aviation',
  LQ: 'Lan Perú',
  LP: 'LATAM Perú',
  MH: 'Malaysia Airlines',
  ME: 'Middle East Airlines',
  MF: 'XiamenAir',
  MK: 'Air Mauritius',
  ML: 'Air Mediterranean',
  MI: 'SilkAir',
  MJ: 'Mihin Lanka',
  MD: 'Air Madagascar',
  MA: 'Malév Hungarian Airlines',
  MV: 'Air Mediterranean',
  N7: 'Nordic Regional Airlines',
  MU: 'China Eastern Airlines',
  N6: 'Nomad Aviation',
  N9: 'Kabo Air',
  MW: 'Mokulele Airlines',
  MN: 'Kulula.com',
  MM: 'Peach Aviation',
  MP: 'Martinair',
  MO: 'Calm Air',
  N3: 'Omskavia',
  N2: 'Dagestan Airlines',
  MQ: 'Envoy Air',
  MT: 'Thomas Cook Airlines',
  MS: 'EgyptAir',
  N4: 'Nordwind Airlines',
  NF: 'Air Vanuatu',
  NG: 'Lauda Air',
  NH: 'All Nippon Airways',
  NK: 'Spirit Airlines',
  NL: 'Shaheen Air',
  NM: 'Manx2',
  NB: 'Sterling Airlines',
  NZ: 'Air New Zealand',
  NY: 'Air Iceland Connect',
  NX: 'Air Macau',
  NW: 'Northwest Airlines',
  O8: 'Siam Air',
  NV: 'Air Central',
  O7: 'OzJet',
  NU: 'Japan Transocean Air',
  NT: 'Binter Canarias',
  NS: 'Hebei Airlines',
  O4: 'Antrak Air',
  NR: 'Pamir Airways',
  NQ: 'Air Japan',
  O2: 'Linear Air',
  NO: 'Neos',
  NN: 'VIM Airlines',
  OM: 'MIAT Mongolian Airlines',
  ON: 'Nauru Airlines',
  OK: 'Czech Airlines',
  OL: 'OLT Express Germany',
  OJ: 'Overland Airways',
  OH: 'Comair',
  OF: 'Overland Airways',
  OC: 'Omni Air International',
  OA: 'Olympic Air',
  OX: 'Orient Thai Airlines',
  P9: 'Peruvian Airlines',
  OW: 'Sky Horizon',
  P8: 'Pantanal Linhas Aéreas',
  OZ: 'Asiana Airlines',
  OY: 'Andes Líneas Aéreas',
  OT: 'Aeropelican Air Services',
  P5: 'Wingo',
  OS: 'Austrian Airlines',
  P4: 'Aerolíneas Sosa',
  OV: 'SalamAir',
  P6: 'Pascan Aviation',
  OU: 'Croatia Airlines',
  OO: 'SkyWest Airlines',
  P0: 'Proflight Zambia',
  OR: 'TUI fly Netherlands',
  P2: 'AirKenya Express',
  OQ: 'Chongqing Airlines',
  PL: 'Southern Air Charter',
  PN: 'West Air',
  Q0: 'Quebecair Express',
  PO: 'Polar Air Cargo',
  PH: 'Transair',
  PJ: 'Air Saint-Pierre',
  PD: 'Porter Airlines',
  PF: 'Primera Air',
  PG: 'Bangkok Airways',
  PB: 'Provincial Airlines',
  HK: 'Yangon Airways',
  HH: 'Taban Air',
  HI: 'Papillon Grand Canyon Helicopters',
  HN: 'Afrijet Business Service',
  HO: 'Juneyao Air',
  HM: 'Air Seychelles',
  HR: 'Hahn Air',
  I3: 'Aerolink Uganda',
  HS: 'Direktflyg',
  HQ: 'Thomas Cook Airlines Belgium',
  HV: 'Transavia',
  I8: 'Izhavia',
  HW: 'North-Wright Airways',
  HU: 'Hainan Airlines',
  HZ: 'Aurora',
  HY: 'Uzbekistan Airways',
  I9: 'Air Italy',
  HX: 'Hong Kong Airlines',
  IC: 'Indian Airlines',
  IB: 'Iberia',
  IA: 'Iraqi Airways',
  IH: 'Southern Air',
  IG: 'Air Italy',
  IF: 'Islas Airways',
  IE: 'Solomon Airlines',
  IJ: 'Spring Airlines Japan',
  IO: 'IrAero',
  J0: 'Jetlink Express',
  IP: 'Atyrau Airways',
  J2: 'Azerbaijan Airlines',
  IQ: 'Qazaq Air',
  J3: 'Northwestern Air',
  IR: 'Iran Air',
  IS: 'Island Airlines',
  J5: 'Alaska Seaplanes',
  J6: 'Jet Operational',
  J7: 'Centre-Avia',
  IV: 'Wind Jet',
  J8: 'Berjaya Air',
  IW: 'Wings Air',
  J9: 'Jazeera Airways',
  IX: 'Air India Express',
  IZ: 'Arkia',
  IY: 'Yemenia',
  JA: 'JetSmart',
  JC: 'Cambodia International Airlines',
  JE: 'Mango',
  JD: 'Beijing Capital Airlines',
  JF: 'Jet Asia Airways',
  JI: 'Meraj Airlines',
  JH: 'Fuji Dream Airlines',
  JP: 'Adria Airways',
  K2: 'Eurolot',
  JQ: 'Jetstar Airways',
  JN: 'JOON',
  JO: 'JALways',
  JL: 'Japan Airlines',
  JM: 'Air Jamaica',
  JJ: 'LATAM Brasil',
  JK: 'Spanair',
  K9: 'KrasAvia',
  JY: 'interCaribbean Airways',
  JV: 'Bearskin Airlines',
  K5: 'Wings of Alaska',
  JT: 'Lion Air',
  JU: 'Air Serbia',
  K3: 'Taquan Air',
  JR: 'Joy Air',
  K4: 'Kalitta Air',
  JS: 'Air Koryo',
  KB: 'Druk Air',
  KA: 'Cathay Dragon',
  JZ: 'Skyways',
  KG: 'Aerogaviota',
  KF: 'Air Belgium',
  KE: 'Korean Air',
  KC: 'Air Astana',
  KO: 'Alaska Central Express',
  KP: 'Asky Airlines',
  KQ: 'Kenya Airways',
  KR: 'Cambodia Angkor Air',
  KK: 'AtlasGlobal',
  KL: 'KLM',
  KL1: 'KLM',
  KM: 'Air Malta',
  KW: 'Wataniya Airways',
  KX: 'Cayman Airways',
  L9: 'Belle Air Europe',
  L4: 'Air Liaison',
  KS: 'PenAir',
  L5: 'Atlas Atlantic Airlines',
  KT: 'SiAvia',
  L6: 'Mauritania Airlines',
  KU: 'Kuwait Airways',
  LA: 'LATAM Chile',
  LB: 'Air Costa',
  LI: 'LIAT',
  LH: 'Lufthansa',
  LH1: 'Lufthansa',
  LJ: 'Jin Air',
  LE: 'Lugansk Airlines',
  LG: 'Luxair',
  LF: 'Contour Aviation',
  PA: 'Airbus Transport International',
  VT: 'Air Tahiti',
  W5: 'Mahan Air',
  W6: 'Wizz Air',
  VU: "Air Côte d'Ivoire",
  W3: 'Arik Air',
  VR: 'Cabo Verde Airlines',
  VS: 'Virgin Atlantic',
  VQ: 'Novoair',
  VN: 'Vietnam Airlines',
  VO: 'Tyrolean Airways',
  VJ: 'VietJet Air',
  VK: 'Level Europe',
  QH: 'Bamboo Airways',
  VH: 'Aeropostal Alas de Venezuela',
  VI: 'Vieques Air Link',
  VF: 'Valuair',
  VG: 'VLM Airlines',
  VE: 'Volare Airlines',
  VC: 'Via Air',
  VA: 'Virgin Australia',
  UZ: 'Buraq Air',
  V9: 'Van Air Europe',
  UX: 'Air Europa',
  UW: 'Uni-Top Airlines',
  V8: 'Iliamna Air Taxi',
  V6: 'VIP Ecuador',
  UU: 'Air Austral',
  V3: 'Carpatair',
  US: 'US Airways',
  UT: 'UTair Aviation',
  V5: 'Danube Wings',
  UM: 'Air Zimbabwe',
  UN: 'Transaero Airlines',
  UO: 'HK Express',
  UP: 'Bahamasair',
  UI: 'Aurigny',
  UJ: 'AlMasria Universal Airlines',
  UL: 'SriLankan Airlines',
  UL1: 'SriLankan Airlines',
  UE: 'BizJet Air',
  UF: 'Petropavlovsk-Kamchatsky Air Enterprise',
  UG: 'Tunisair Express',
  UA: 'United Airlines',
  UD: "Hex'Air",
  UC: 'LATAM Cargo Chile',
  TY: 'Air Calédonie',
  TX: 'Air Caraïbes',
  U9: 'Tatarstan Airlines',
  TU: 'Tunisair',
  U6: 'Ural Airlines',
  TT: 'Tigerair Australia',
  U5: 'USA 3000 Airlines',
  U8: 'Armavia',
  U7: 'Air Uganda',
  Y3: 'Hermes Airlines',
  XR: 'Corendon Airlines Europe',
  Y4: 'Volaris',
  XP: 'Xtra Airways',
  XQ: 'SunExpress',
  XV: 'Buraq Air',
  XW: 'NokScoot',
  Y8: 'Suparna Airlines',
  Y5: 'Golden Myanmar Airlines',
  PK: 'Pakistan International Airlines',
  XT: 'Indonesia AirAsia X',
  XU: 'African Express Airways',
  XJ: 'Thai AirAsia X',
  XK: 'Air Corsica',
  XN: 'Xpress Air',
  Y0: 'Yellow Air Taxi',
  XO: 'LTE International Airways',
  XL: 'LATAM Ecuador',
  XM: 'Alitalia Express',
  XG: 'SunExpress Deutschland',
  XF: 'Vladivostok Air',
  XE: 'ExpressJet',
  WY: 'Oman Air',
  WX: 'CityJet',
  WW: 'WOW air',
  X8: 'Icaro Air',
  WO: 'World Airways',
  WP: 'Island Air',
  WR: 'WestJet Encore',
  X3: 'TUIfly',
  WS: 'WestJet',
  X4: 'Air Excursions',
  WT: 'Wasaya Airways',
  X5: 'Afrique Airlines',
  WU: 'Wizz Air Ukraine',
  X7: 'Air Service',
  WG: 'Sunwing Airlines',
  WI: 'White Airways',
  WJ: 'Air Labrador',
  WK: 'Edelweiss Air',
  WM: 'Winair',
  WN: 'Southwest Airlines',
  WB: 'RwandAir',
  WA: 'KLM Cityhopper',
  WC: 'Islas Airways',
  WF: 'Widerøe',
  VW: 'Aeromar',
  VV: 'Aerosvit Airlines',
  VY: 'Vueling',
  VX: 'Virgin America',
  VZ: 'Thai VietJet Air',
  RI: 'Mandala Airlines',
  RH: 'Air Nostrum',
  RF: 'Eurofly',
  RE: 'Aer Arann',
  RB: 'Syrian Air',
  S2: 'Air Sahara',
  RQ: 'Kam Air',
  RP: 'Chautauqua Airlines',
  S0: 'Slok Air International',
  RO: 'TAROM',
  RM: 'Regional Air',
  RJ: 'Royal Jordanian',
  QW: 'Qingdao Airlines',
  QX: 'Horizon Air',
  R9: 'Camai Air',
  R6: 'DOT LT',
  QV: 'Lao Airlines',
  R7: 'Aserca Airlines',
  QS: 'Smartwings',
  R4: 'State Transport Company Russia',
  QT: 'Avianca Cargo',
  R5: 'Jordan Aviation',
  QQ: 'Alliance Airlines',
  R2: 'Orenair',
  QR: 'Qatar Airways',
  QR1: 'Qatar Airways',
  RA: 'Nepal Airlines',
  QY: 'DHL Aviation',
  QZ: 'Indonesia AirAsia',
  QF: 'Qantas',
  QF1: 'Qantas',
  QE: 'Express Freighters Australia',
  QG: 'Citilink',
  QA: 'Cimber Air',
  QC: 'Camair-Co',
  QM: 'Air Malawi',
  QJ: 'Jetline',
  QI: 'Cimber Sterling',
  QL: 'Laser Airlines',
  QK: 'Air Canada Jazz',
  Q5: 'Forty Mile Air',
  PU: 'Plus Ultra Líneas Aéreas',
  PV: 'Saint Barth Commuter',
  PW: 'Precision Air',
  Q8: 'Trans Air Congo',
  PP: 'Jet Aviation',
  PQ: 'AirAsia Philippines',
  PR: 'Philippine Airlines',
  PS: 'Ukraine International Airlines',
  Q4: 'StarLux Airlines',
  PX: 'Air Niugini',
  PY: 'Surinam Airways',
  PZ: 'LATAM Paraguay',
  TG: 'Thai Airways',
  TF: 'Braathens Regional Airlines',
  TD: 'Atlantis European Airways',
  TK: 'Turkish Airlines',
  TH: 'Raya Airways',
  TN: 'Air Tahiti Nui',
  TM: 'LAM Mozambique Airlines',
  TL: 'Air North',
  TS: 'Air Transat',
  U4: 'Buddha Air',
  TR: 'Scoot',
  U3: 'Avies',
  TQ: 'Tandem Aero',
  U2: 'EasyJet',
  TP: 'TAP Air Portugal',
  SU: 'Aeroflot',
  SV: 'Saudia',
  T7: 'Twin Jet',
  SS: 'Corsair International',
  T5: 'Turkmenistan Airlines',
  SY: 'Sun Country Airlines',
  SZ: 'Somon Air',
  T8: 'Air Namibia',
  SW: 'Air Namibia',
  T9: 'Turkuaz Airlines',
  TB: 'TUI fly Belgium',
  TC: 'Thomas Cook Airlines',
  TA: 'Avianca El Salvador',
  SD: 'Sudan Airways',
  SC: 'Shandong Airlines',
  SF: 'Tassili Airlines',
  SE: 'XL Airways France',
  SG: 'SpiceJet',
  SJ: 'Sriwijaya Air',
  SI: 'Blue Islands',
  SL: 'Thai Lion Air',
  SK: 'Scandinavian Airlines',
  SN: 'Brussels Airlines',
  SM: 'Air Cairo',
  SP: 'SATA Air Açores',
  T3: 'Eastern Airways',
  SQ: 'Singapore Airlines',
  T2: 'Fly_Anisec',
  RR: 'Royal Air Force',
  S3: 'SBA Airlines',
  S4: 'SATA International',
  RT: 'JSC UVT Aero',
  S5: 'Star Air',
  S6: 'Sunrise Airways',
  S7: 'S7 Airlines',
  RV: 'Caspian Airlines',
  RW: 'Republic Airways',
  RY: 'Royal Wings',
  SA: 'South African Airways',
  SA1: 'South African Airways',
  SB: 'Aircalin',
  ZA: 'SkyJet Airlines',
  ZG: 'Zipair Tokyo',
  ZH: 'Shenzhen Airlines',
  ZI: 'Aigle Azur',
  ZN: 'Zenith Aviation',
  ZP: 'Paranair',
  ZK: 'Air New Zealand Link',
  ZJ: 'Zambia Skyways',
  ZL: 'Regional Express',
  ZW: 'Air Wisconsin',
  ZM: 'Air Manas',
  ZY: 'Sky Aviation',
  ZX: 'Zoom Airlines',
  ZR: 'Aviacon Zitotrans',
  ZU: 'Helios Airways',
  XZ: 'South African Express',
  Y9: 'Kish Air',
  YH: 'Sunsplash Aviation',
  YE: 'YanAir',
  YC: 'Yamal Airlines',
  YD: 'Mauritania Airlines International',
  YB: 'Línea Aérea Amaszonas',
  YO: 'Heli Air Monaco',
  YN: 'Air Creebec',
  YM: 'Montenegro Airlines',
  YL: 'Yamal Airlines',
  YJ: 'AMC Airlines',
  YI: 'Air Sunshine',
  YW: 'Air Nostrum',
  YV: 'Mesa Airlines',
  Z6: 'Dniproavia',
  YT: 'Yeti Airlines',
  Z5: 'Africa World Airlines',
  YS: 'Régional',
  Z4: 'Zagrosjet',
  YR: 'Scenic Airlines',
  Z3: 'Bidzyaza Airlines',
  Z2: 'Philippines AirAsia',
  YQ: 'Polet Airlines',
  '3A': 'Chu Kong Passenger Transport',
  '3B': 'JobAir',
  '2U': "Sun d'Or",
  '2X': 'Amadeus IT Group',
  '2Y': 'PT. Myindo Express Airlines',
  '2W': 'Welcome Air',
  '3M': 'Silver Airways',
  '3L': 'Intersky',
  '3K': 'Jetstar Asia',
  '3R': 'AviaExpress',
  '3Q': 'Carib Aviation',
  '3O': 'Air Arabia Maroc',
  '3F': 'Pacific Airways',
  '3E': 'Air Choice One',
  '3D': 'Dokasch',
  '3C': 'AirCongo',
  '3H': 'Air Inuit',
  '1T': '1Time Airline',
  '1X': 'Branson Air Express',
  '2K': 'Avianca Ecuador',
  '2J': 'Air Burkina',
  '2M': 'Moldavian Airlines',
  '2L': 'Helvetic Airways',
  '2O': 'Island Air',
  '2Q': 'Air Cargo Carriers',
  '2B': 'Albawings',
  '2E': 'Smokey Bay Air',
  '2G': 'Angara Airlines',
  '2F': 'Frontier Flying Service',
  '2I': 'Star Perú',
  '0Y': 'FlyYeti',
  '0D': 'Darwin Airline',
  '6Y': 'SmartLynx Airlines',
  '7B': 'FlyLAL',
  '7A': 'Express Air',
  '7F': 'First Air',
  '7E': 'Sylt Air',
  '7D': 'Donbassaero',
  '7I': 'Insel Air',
  '7J': 'Tajik Air',
  '7H': 'Ravn Alaska',
  '7N': 'Inland Aviation',
  '7Q': 'Pan Africa Airline',
  '7R': 'RusLine',
  '7P': 'Air Panama',
  '7V': 'Federal Airlines',
  '7S': 'Ryan Air',
  '7T': 'Trans North Aero',
  '5V': 'Lviv Airlines',
  '5U': 'Transportes Aéreos Guatemaltecos',
  '5W': 'Wizz Air Abu Dhabi',
  '5Z': 'Bismillah Airlines',
  '6C': 'Cape Smythe Air Service',
  '6E': 'IndiGo',
  '6G': 'Sun Air',
  '6H': 'Israir Airlines',
  '6I': 'Alsie Express',
  '6J': 'Solaseed Air',
  '6K': 'Asian Spirit',
  '6L': 'Aklak Air',
  '6N': 'Niger Airlines',
  '6P': 'Clubair',
  '6Q': 'Cham Wings Airlines',
  '6T': 'Air Mandalay',
  '4Y': 'Discover Airlines',
  '4W': "Warbelow's Air Ventures",
  '4V': 'Birdy Airlines',
  '4U': 'Germanwings',
  '4T': 'Belair',
  '5D': 'Aeroméxico Connect',
  '5C': 'Nature Air',
  '5B': 'Euro-Asia Air',
  '5K': 'Hi Fly',
  '5L': 'AeroSur',
  '5J': 'Cebu Pacific',
  '5G': 'Skyservice Airlines',
  '5H': 'Fly540',
  '5E': 'Siam Land Flying',
  '5F': 'Arctic Circle Air',
  '5S': 'Servicios Aéreos Profesionales',
  '5T': 'Canadian North',
  '5Q': 'BQB Líneas Aéreas',
  '5O': 'ASL Airlines France',
  '5P': 'SkyExpress',
  '5N': 'Smartavia',
  '3X': 'Japan Air Commuter',
  '3Z': 'Smartwings Poland',
  '3Y': 'Baseops International',
  '3S': 'Aerologic',
  '3U': 'Sichuan Airlines',
  '4A': 'ATSA Airlines',
  '4C': 'LATAM Colombia',
  '4B': 'Perimeter Aviation',
  '4H': 'United Airways',
  '4I': 'Izmir Airlines',
  '4J': 'Somon Air',
  '4K': 'Kenn Borek Air',
  '4D': 'Air Sinai',
  '4F': 'Air City',
  '4G': 'Gazpromavia',
  '4P': 'Viking Airlines',
  '4Q': 'Safi Airways',
  '4Q1': 'Safi Airways',
  '4R': 'Hamburg International',
  '4L': 'Lineas Aereas Canadas',
  '4M': 'LATAM Argentina',
  '4N': 'Air North',
  '4O': 'Interjet',
  '9V': 'Avior Airlines',
  '9U': 'Air Moldova',
  '9X': 'Southern Airways Express',
  '9W': 'Jet Airways',
  '9W1': 'Jet Airways',
  '9Q': 'Caicos Express Airways',
  '9T': 'ACT Airlines',
  '9N': 'Satena',
  '9M': 'Central Mountain Air',
  '9P': 'Air Arabian',
  '9J': 'Dana Air',
  '9L': 'Colgan Air',
  '9K': 'Cape Air',
  '9E': 'Endeavor Air',
  '9H': 'MDLR Airlines',
  '9C': 'Spring Airlines',
  '9D': 'Toumaï Air Tchad',
  '8Z': 'Wizz Air Bulgaria',
  '8W': 'Private Wings',
  '8V': 'Wright Air Service',
  '8U': 'Afriqiyah Airways',
  '8T': 'Air Tindi',
  '8P': 'Pacific Coastal Airlines',
  '8N': 'Regional Jet',
  '8M': 'Myanmar Airways International',
  '8J': 'Eco Jet',
  '8H': 'Highland Airways',
  '8F': 'STP Airways',
  '8D': 'Servant Air',
  '8E': 'Bering Air',
  '8A': 'Atlas Blue',
  '7Y': 'Mann Yadanarpon Airlines',
  '7Z': 'Halcyon Air',
  '7W': 'Windrose Airlines',
  SG9: 'SpiceJet',
  UK: 'Vistara',
  U22: 'EasyJet',
  DY2: 'Norwegian Air Shuttle',
  VY2: 'Vueling',
  OP: 'Air Pegasus',
  YK: 'Avia Traffic Company',
  GK: 'Jetstar Japan',
  K6: 'Cambodia Angkor Air',
  '2T': 'TruJet',
  OD: 'Batik Air Malaysia',
  UB: 'Myanmar National Airlines',
  RX: 'Regent Airways',
  K7: 'Air KBZ',
  NA: 'Supreme Airlines',
  AD: 'Azul Brazilian Airlines',
  XY: 'Flynas',
  H1: 'Hahn Air Systems',
  SG2: 'SpiceJet',
  SG3: 'SpiceJet',
  '7C': 'Jeju Air',
  OG: 'Star Air',
  S9: 'FlyBig',
  QP: 'Akasa Air',
  '9I': 'Alliance Air',
  WE: 'Thai Smile',
  UR: 'Uganda Airlines',
};

export default AIRLINE_NAMES_FOR_CARRIER_CODE;
